(function () {
  'use strict';

  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');
  if (!finePointer || !finePointer.matches) return;

  function findLink(target) {
    if (!(target instanceof Element)) return null;
    return target.closest('.product-card-gallery__link, .us-product-image-link');
  }

  function showSecondaryImage(link) {
    var primaryImage = link.querySelector('img');
    var secondaryImage = link.querySelector('[data-secondary-hover-image]');

    if (!primaryImage || !secondaryImage) return;
    primaryImage.style.opacity = '0';
    secondaryImage.style.opacity = '1';
  }

  function hideSecondaryImage(link) {
    var primaryImage = link.querySelector('img');
    var secondaryImage = link.querySelector('[data-secondary-hover-image]');

    if (!primaryImage || !secondaryImage) return;
    primaryImage.style.opacity = '1';
    secondaryImage.style.opacity = '0';
  }

  function loadSecondaryImage(link) {
    if (link.dataset.hoverImageState) {
      if (link.dataset.hoverImageState === 'ready') showSecondaryImage(link);
      return;
    }

    var primaryImage = link.querySelector('img');
    if (!primaryImage || !link.href) return;

    link.dataset.hoverImageState = 'loading';

    var productUrl;
    try {
      productUrl = new URL(link.href, window.location.href);
    } catch (error) {
      link.dataset.hoverImageState = 'failed';
      return;
    }

    fetch(productUrl.pathname + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to load product hover image');
        return response.json();
      })
      .then(function (product) {
        if (!product.images || product.images.length < 2 || !link.isConnected) {
          link.dataset.hoverImageState = 'unavailable';
          return;
        }

        var secondaryImage = document.createElement('img');
        var separator = product.images[1].indexOf('?') === -1 ? '?' : '&';
        secondaryImage.src = product.images[1] + separator + 'width=400';
        secondaryImage.alt = primaryImage.alt || '';
        secondaryImage.dataset.secondaryHoverImage = '';
        secondaryImage.style.cssText =
          'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;opacity:0;transition:opacity .4s ease;';

        primaryImage.style.transition = 'opacity .4s ease';
        link.style.position = 'relative';
        link.appendChild(secondaryImage);
        link.dataset.hoverImageState = 'ready';
        showSecondaryImage(link);
      })
      .catch(function () {
        link.dataset.hoverImageState = 'failed';
      });
  }

  document.addEventListener(
    'pointerover',
    function (event) {
      var link = findLink(event.target);
      if (!link || (event.relatedTarget instanceof Node && link.contains(event.relatedTarget))) return;
      loadSecondaryImage(link);
    },
    true
  );

  document.addEventListener(
    'pointerout',
    function (event) {
      var link = findLink(event.target);
      if (!link || (event.relatedTarget instanceof Node && link.contains(event.relatedTarget))) return;
      hideSecondaryImage(link);
    },
    true
  );
})();
